/**
 * imageCredit.js
 * ──────────────
 * The photo credit line shown under images. Credits live on the media-library
 * file; the server copies them onto blocks and posts as `credit`
 * ({ author, copyright }) when it serves the page. This helper decides
 * whether to show the line and how to word it.
 *
 * Site settings (Site Design → Layout):
 *   imageCredits: 'show' | 'hide'          default 'show'
 *   imageCreditPrefix: 'Photo' | 'Credit' | ''   default 'Photo'
 * Per-image override: showCredit 'site' | 'always' | 'never'
 */

/**
 * @param {Object|null} credit { author, copyright }
 * @param {Object} siteSettings
 * @param {string} [override] 'site' | 'always' | 'never'
 * @returns {string} '' when nothing should show
 */
export function creditLine(credit, siteSettings, override) {
	if (!credit || typeof credit !== 'object') return '';
	var author = String(credit.author || '').trim();
	var copyright = String(credit.copyright || '').trim();
	if (!author && !copyright) return '';
	var mode = override || 'site';
	if (mode === 'never') return '';
	var s = siteSettings || {};
	if (mode === 'site' && (s.imageCredits === 'hide')) return '';
	var prefix = s.imageCreditPrefix === undefined || s.imageCreditPrefix === null ? 'Photo' : String(s.imageCreditPrefix);
	var parts = [];
	if (author) parts.push(prefix ? prefix + ': ' + author : author);
	if (copyright) parts.push(/©|\(c\)/i.test(copyright) ? copyright : '© ' + copyright);
	return parts.join(' · ');
}
